import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SizeDTO,ImageDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class sizeService implements OnInit {
    public Size: SizeDTO[];
    public Source: LocalDataSource;

    constructor(private http: HttpClient, private notifcationService: NotificationService) {
        this.Source = new LocalDataSource();
        //this.Sizes=new Array<SizeDTO>();
    }

    addSize(Size: SizeDTO) {

        return this.http.post(environment.apiUrl + "/Size", Size).subscribe(
            data => {
                this.notifcationService.showSuccess("Size", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Size", "ajout avec success");
                console.error(error);
            }
        );

    }

    updateSize(Size: SizeDTO) {

        return this.http.put(environment.apiUrl + "/Size", Size).subscribe(
            data => {
                this.notifcationService.showSuccess("Size", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Size", "ajout avec success");
                console.error(error);
            }
        );

    }


    getSizes(source: boolean): any {
        if (source) {
            this.http.get<SizeDTO[]>(environment.apiUrl + "/Size").pipe(
                catchError(this.handleError)

            );
        } else {
            this.http.get<SizeDTO[]>(environment.apiUrl + "/Size").pipe(
                catchError(this.handleError)

            );
        }

    }

    getAllSizes(): any {
        return this.http.get<SizeDTO[]>(environment.apiUrl + "/Size")
            .pipe(
                catchError(this.handleError)
            );
    }


    deleteSize(idSize: number) {
        this.http.delete<any>(environment.apiUrl + "/Size/" + idSize).subscribe(
            data => {
                this.notifcationService.showSuccess("Size", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Size", "suppression avec success");
                console.error(error);
            }
        );
    }


    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    };



}

